import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, CssBaseline } from '@mui/material';
import ColorModeContext from './ColorModeContext';
import { createCustomTheme } from './theme/theme';
import './i18n';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const Main: React.FC = () => {
  const [mode, setMode] = React.useState<'light' | 'dark'>(
    localStorage.getItem('theme') === 'dark' ? 'dark' : 'light'
  );
  
  const theme = React.useMemo(() => createCustomTheme(mode), [mode]);

  const colorMode = React.useMemo(() => ({
    toggleColorMode: () => {
      setMode((prev) => {
        const newMode = prev === 'light' ? 'dark' : 'light';
        localStorage.setItem('theme', newMode);
        return newMode;
      });
    },
  }), []);

  return (
    <I18nextProvider i18n={i18n}>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </ColorModeContext.Provider>
    </I18nextProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

reportWebVitals();
